export const localZones: Record<string, string[]> = {
  "Zone 1": [
    "LAGOS OUTSKIRT",
    "OPIC",
    "ALAKUKO",
    "BERGER OUTSKIRTS",
    "ALAGBADO OUTSKIRTS",
    "IKORODU",
    "ALAGBOLE",
    "WAWA",
    "AREPO",
    "MAGBORO",
    "MOWE",
    "ABEOKUTA",
    "ADO EKITI",
    "AKURE",
    "IFE",
    "IJEBU ODE",
    "ILORIN",
    "ILESHA",
  ],
  "Zone 2": [
    "ABA",
    "ASABA",
    "BENIN",
    "BENIN CITY",
    "BONNY",
    "CALABAR",
    "ENUGU",
    "GWAGWALADA",
    "AWKA",
    "OWERRI",
    "OSHOGBO",
    "WARRI",
    "UMUAHIA",
    "UYO",
    "YENAGOA",
    "NNEWI",
    "NSUKKA",
    "ONITSHA",
  ],
  "Zone 3": [
    "BAUCHI",
    "JOS",
    "KADUNA",
    "KANO",
    "KATSINA",
    "KEBBI",
    "LOKOJA",
    "MAKURDI",
    "MAIDUGURI",
    "DAMATURU",
    "MINNA",
    "SOKOTO",
    "YOLA",
    "ZARIA",
  ],
  "Zone 4": [
    "ABUJA",
    "FEDERAL CAPITAL TERRITORY",
    "LAGOS",
    "ABUJA MUNICIPAL AREA COUNCIL",
  ],
  "Zone 5": ["PORT HARCOURT", "PORT-HARCOURT"],
  "Zone 6": ["IBADAN"],
};
export const internationalZones = {
  "Zone 1": ["GUERNSEY", "IRELAND REPUBLIC OF", "JERSEY", "UNITED KINGDOM"],
  "Zone 2": [
    "BENIN",
    "BURKINA FASO",
    "CAMEROON",
    "CAPE VERDE",
    "CENTRAL AFRICAN REPU",
    "CHAD",
    "CONGO",
    "CONGO THE DEMOCRA",
    "COTE D IVOIRE",
    "GABON",
    "GAMBIA",
    "GHANA",
    "GUINEA REPUBLIC",
    "GUINEA-BISSAU",
    "GUINEA-EQUATORIAL",
    "LIBERIA",
    "MALI",
    "NIGER",
    "SAO TOME AND PRINCIPE",
    "SENEGAL",
    "SIERRA LEONE",
    "TOGO",
  ],
  "Zone 3": ["CANADA", "MEXICO", "UNITED STATES"],
  "Zone 4": [
    "ALBANIA",
    "ANDORRA",
    "AUSTRIA",
    "BELARUS",
    "BELGIUM",
    "BOSNIA AND HERZEGOV",
    "BULGARIA",
    "CROATIA",
    "CYPRUS",
    "DENMARK",
    "ESTONIA",
    "F RANC E",
    "FAROE ISLANDS",
    "FINLAND",
    "GERMANY",
    "GIBRALTAR",
    "GREECE",
    "GREENLAND",
    "HUNGARY",
    "ICELAND",
    "ITALY",
    "KOSOVO",
    "LATVIA",
    "LICHTENSTEIN",
    "LITHUANIA",
    "LUXEMBOURG",
    "MACEDONIA, REPUBLIC O",
    "MALTA",
    "MOLDOVA REPUBLIC OF",
    "MONACO",
    "MONTENEGRO, REPUBLIC",
    "NORWAY",
    "POLAND",
    "PORTUGAL",
    "ROMANIA",
    "SAN MARINO",
    "SERBIA, REPUBLIC OF",
    "SLOVAKIA",
    "SLOVENIA",
    "SPAIN",
    "SWEDEN",
    "SWITZERLAND",
    "THE CANARY ISLANDS",
    "THE CZECH REPUBLIC",
    "THE NETHERLANDS",
    "THE RUSSIAN FEDERATION",
    "TURKEY",
    "UKRAINE",
  ],
  "Zone 5": [
    "ALGERIA",
    "ANGOLA",
    "BOTSWANA",
    "BURUNDI",
    "COMOROS",
    "DJIBOUTI",
    "EGYPT",
    "ERITREA",
    "ETHIOPIA",
    "KENYA",
    "LESOTHO",
    "LIBYA",
    "MADAGASCAR",
    "MALAWI",
    "MAURITANIA",
    "MAURITIUS",
    "MAYOTTE",
    "MOROCCO",
    "MOZAMBIQUE",
    "NAMIBIA",
    "REUNION, ISLAND OF",
    "RWANDA",
    "SEYCHELLES",
    "SOMALIA",
    "SOMALILAND",
    "SOUTH AFRICA",
    "SOUTH SUDAN",
    "SUDAN",
    "SWAZILAND",
    "TANZANIA",
    "TUNISIA",
    "UGANDA",
    "ZAMBIA",
    "ZIMBABWE",
  ],
  "Zone 6": [
    "AFGHANISTAN",
    "BAHRAIN",
    "IRAN ISLAMIC REPUBLIC",
    "IRAQ",
    "ISRAEL",
    "JORDAN",
    "KUWAIT",
    "LEBANON",
    "QATAR",
    "SAUDI ARABIA",
    "SYRIA",
    "UNITED ARAB EMIRATES",
    "YEMEN REPUBLIC OF",
  ],
  "Zone 7": [
    "ARMENIA",
    "AUSTRALIA",
    "AZERBAIJAN",
    "BANGLADESH",
    "BHUTAN",
    "BRUNEI",
    "CAMBODIA",
    "CHINA, PEOPLES REPUB",
    "EAST TIMOR",
    "GEORGIA",
    "HONG KONG",
    "INDIA",
    "INDONESIA",
    "JAPAN",
    "KAZAKHSTAN",
    "KOREA REPUBLIC OF so",
    "KOREA THE D.P.R OF NO",
    "KYRGYZSTAN",
    "LAO PEOPLES DEMOCRAT",
    "MACAU",
    "MALAYSIA",
    "MALDIVES",
    "MONGOLIA",
    "MYANMAR",
    "NEPAL",
    "PAKISTAN",
    "PALAU",
    "SINGAPORE",
    "SRI LANKA",
    "TAIWAN",
    "TAJIKISTAN",
    "THAILAND",
    "THE PHILIPPINES",
    "UZBEKISTAN",
    "VIETNAM",
  ],
  "Zone 8": [
    "AMERICAN SAMOA",
    "ANGUILLA",
    "ANTIGUA",
    "ARGENTINA",
    "ARUBA",
    "BAHAMAS",
    "BARBADOS",
    "BELIZE",
    "BERMUDA",
    "BOLIVIA",
    "BONAIRE",
    "BRAZIL",
    "CAYMAN ISLANDS",
    "CHILE",
    "COLOMBIA",
    "COMMONWEALTH NO.",
    "COOK ISLANDS",
    "COSTA RICA",
    "CUBA",
    "CURACAO",
    "DOMINICA",
    "DOMINICAN REPUBLIC",
    "ECUADOR",
    "EL SALVADOR",
    "FALKLAND ISLANDS",
    "FIJI",
    "FRENCH GUYANA",
    "GRENADA",
    "GUADELOUPE",
    "GUAM",
    "GUATEMALA",
    "GUYANA BRITISH",
    "HAITI",
    "HONDURAS",
    "JAMAICA",
    "KIRIBATI",
    "MARSHALL ISLANDS",
    "MARTINIQUE",
    "MICRONESIA, FEDERATED",
    "MONTSERRAT",
    "NAURU REPUBLIC OF",
    "NEVIS",
    "NEW CALEDONIA",
    "NEW ZEALAND",
    "NICARAGUA",
    "Nil-IE",
    "PANAMA",
    "PAPUA NEW GUINEA",
    "PARAGUAY",
    "PERU",
    "PUERTO RICO",
    "SAINT HELENA",
    "SAMOA",
    "SOLOMON ISLANDS",
    "ST. BARTHELEMY",
    "ST. EUSTATIUS",
    "ST. KITTS",
    "ST. LUCIA",
    "ST. MAARTEN",
    "ST. VINCENT",
    "SURINAME",
    "TAHITI",
    "TONGA",
    "TRINIDAD AND TOBAGO",
    "TURKS AND CAICOS ISLANDS",
    "TUVALU",
    "URUGUAY",
    "VANUATU",
    "VENEZUELA",
    "VIRGIN ISLANDS BRITISH",
    "VIRGIN ISLANDS US",
  ],
};

export const LocationsNotCoveredInLagos = [
  "Agbara",
  "Ijedodo",
  "Ajangbadi",
  "Ikorodu",
  "Alagbado outskirts",
  "Ishaga Road",
  "Alagbole",
  "Jankara",
  "Alakuko",
  "Ojo",
  "Awoyaya",
  "Ojodu Berger outskirts",
  "Badagry",
  "Opic",
  "Epe",
  "Sango",
  "Ibeju",
  "Tradefair",
  "Okokomaiko",
];

export const isAbujaPickupWithInvalidDeliveries = (
  pickupState: string,
  deliveries: any[]
): boolean => {
  if (!pickupState) return false;

  const isAbuja =
    pickupState.toLowerCase().includes("abuja") ||
    pickupState.toLowerCase().includes("federal capital territory");

  if (!isAbuja) return false;

  // If pickup is Abuja, every delivery must be in Lagos
  return deliveries.some(
    (delivery) => !delivery.d_state?.toLowerCase().includes("lagos")
  );
};

export const isLagosPickupWithInvalidDeliveries = (
  pickupState: string,
  deliveries: any[]
): boolean => {
  console.log(pickupState, deliveries);
  if (!pickupState) return false;

  const isLagos = pickupState.toLowerCase().includes("lagos");

  if (!isLagos) return false;

  return deliveries.some((delivery) =>
    delivery.d_state?.toLowerCase().includes("lagos")
  );
};

export const isLocationNotAccepted = (
  locationArray: {long_name: string; types: string[]}[],
  accountType: string
): boolean => {
  const adminAreaLevel2 = locationArray.find((loc) =>
    loc.types.includes("administrative_area_level_2")
  )?.long_name;
  if (!adminAreaLevel2) return false;
  if (accountType === "WITHIN_LAGOS") {
    return LocationsNotCoveredInLagos.includes(adminAreaLevel2);
  } else {
    return false;
  }
};

export const isLocationNotAcceptedWithoutArray = (
  location: string,
  accountType: string
): boolean => {
  if (accountType === "WITHIN_LAGOS") {
    return LocationsNotCoveredInLagos.includes(location);
  } else {
    return false;
  }
};

export function getZone(
  accountType: string,
  stateValue: string
): string | undefined {
  const value = stateValue?.toUpperCase();

  if (accountType === "WITHIN_LAGOS") {
    return value === "LAGOS" ? "Zone 1" : undefined;
  }

  if (accountType === "OUTSIDE_LAGOS") {
    for (const [zone, cities] of Object.entries(localZones)) {
      if (cities.includes(value)) {
        return zone;
      }
    }
    return undefined;
  }

  if (accountType === "OUTSIDE_NIGERIA") {
    for (const [zone, countries] of Object.entries(internationalZones)) {
      if (countries.includes(value)) {
        return zone;
      }
    }
    return undefined;
  }

  return undefined;
}

export const calculateCreditsFromWeight = (weight: number) => {
  if (weight <= 3) return 1;
  if (weight <= 6) return 2;
  if (weight <= 9) return 3;
  if (weight <= 12) return 4;
  return 5;
};
